import Index from "./pages/Index";

import "./App.css";

const App = () => {
  return (
    <div>
      <Index />
    </div>
  );
};

export default App;
